import moment from "moment";

// Helper function to check if subscription expires soon and get remaining days
const getExpiryStatus = (endDate) => {
  // Use startOf('day') to get only date without time for accurate date comparison
  const today = moment().startOf('day');
  const expiryDate = moment(endDate).startOf('day');
  const daysRemaining = expiryDate.diff(today, "days");


  if (daysRemaining <= 7 && daysRemaining >= 0) {

    return {
      isExpiringSoon: true,
      daysRemaining: daysRemaining,
      color: daysRemaining <= 3 ? "error" : "warning",
      severity: daysRemaining <= 3 ? "critical" : "warning",
    };
  } else if (daysRemaining < 0) {
    return {
      isExpired: true,
      daysRemaining: Math.abs(daysRemaining),
      color: "error",
      severity: "expired",
    };
  }
  return {
    isExpiringSoon: false,
    isExpired: false,
    daysRemaining: daysRemaining,
    color: "success",
    severity: "active",
  };
};

export default getExpiryStatus;